<template>
  <Dialog
    v-model:visible="showEmailDialog"
    :style="{ width: '650px' }"
    header="Document Email"
    :modal="true"
    class="theme-dialog"
    maximizable
    @hide="closeEmailDialogue()"
  >
    <div class="document-email flex flex-column">
      <div class="w-12 flex flex-column">

        <!-- Using .flex with .grid is required because TailwindCSS .grid applies "display: grid" -->

        <!-- To -->
        <div class="grid flex align-items-center my-1 mx-0" :class="this.emtpyEmailToError ? 'deerror' : ''">
          <label class="col-fixed label">To</label>
          <Dropdown v-if="type=='RCON' || type=='RCONBOL'"
            v-model="selectedEmail"
            :options="emaillist"
            :style="'padding:0px'"
            class="col form-control border-control documentemail-dropdown"
            placeholder="Select"
            @change="changeSelectedEmail($event)"
          />
          <Chips
          v-else
          v-model="selectedEmail"
          @add="validateEmailList('to')"
          @remove="removeEmail($event,'to')"
          separator=" "
          :class="this.emtpyEmailToError &&(!selectedEmail || selectedEmail.length==0)?'chipError':''"
          class="col border-control p-0"
          :max="50"
          :allowDuplicate="false"
          addOnBlur=true
          aria-autocomplete="false"   
          aria-describedby="help-text"
          >
          <template #chip="slotProps">
            <div v-if="!isEmailValid(slotProps.value)">
              <span class="text-red-500">{{ slotProps.value }} </span>
              <i class="ml-1 pi pi-exclamation-circle text-red-500" style="font-size: 14px" v-tooltip.right="{ value: 'Invalid Email.', class: 'tooltip-features' }"></i>
            </div>
          </template>
        </Chips>
        </div>
        <!-- CC -->
        <div class="grid flex align-items-center my-1 mx-0">
          <label class="col-fixed label label-align">CC</label>
            <Chips
              v-model="DraftEmail.EmailCC"
              @add="validateEmailList('cc')"
              @remove="removeEmail($event,'cc')"
              separator=" "
              class="col border-control p-0"
              aria-autocomplete="false"
              :max="50"
              :allowDuplicate="false"  
              addOnBlur=true
              aria-describedby="help-text"
          >
          <template #chip="slotProps">
            <div v-if="!isEmailValid(slotProps.value)">
              <span class="text-red-500">{{ slotProps.value }} </span>
              <i class="ml-1 pi pi-exclamation-circle text-red-500" style="font-size: 14px" v-tooltip.right="{ value: 'Invalid Email.', class: 'tooltip-features' }"></i>
            </div>
          </template>
        </Chips>
        </div>
        <!-- BCC -->
        <div class="grid flex align-items-center my-1 mx-0" :class="this.invalidEmailBCCError ? 'deerror' : ''">
          <label class="col-fixed label">BCC</label>
          <Chips
            v-model="DraftEmail.EmailBCC"
            @add="validateEmailList('bcc')"
            @remove="removeEmail($event,'bcc')"
            separator=" "
            class="col border-control p-0"
            placeholder=""
            :max="50"
            :allowDuplicate="false"
            addOnBlur=true
            aria-autocomplete="false"
            aria-describedby="help-text"
          >
          <template #chip="slotProps">
            <div v-if="!isEmailValid(slotProps.value)">
              <span class="text-red-500">{{ slotProps.value }} </span>
              <i class="ml-1 pi pi-exclamation-circle text-red-500" style="font-size: 14px" v-tooltip.right="{ value: 'Invalid Email.', class: 'tooltip-features' }"></i>
            </div>
          </template>
        </Chips>
        </div>

        <!-- Subject -->
        <div class="grid flex align-items-center my-1 mx-0">
          <label class="col-fixed label">Subject</label>
          <input
            v-model="DraftEmail.Subject"
            type="text"
            class="col email-form-control border-control"
            placeholder="Enter Text"
          />
        </div>

        <!-- Attachments -->
        <div class="grid flex align-items-center my-1 mx-0">
          <label class="col-fixed label">Attachments</label>
          <input
            v-model="attachments"
            type="text"
            class="col email-form-control border-control"
            placeholder=""
            disabled
          />
        </div>
        <!--  /// Do not delete, /// will help if want to open attachment in email popup 

              <div class="w-12 mr-2 mt-2 flex">
                  <label class="w-2 label">Attachments</label>
                  <div class="attach-form-control mr-1 border-control flex">
                  <a type="text"
                  v-for="(documentEmail, index) in this.selectedDocuments" :key="index"
                      :value="documentEmail.OriginalFileName"
                      @click="getPdf(documentEmail.FullPath)"
                      class="email-docs mr-1 border-control"
                      placeholder=""
                  >{{documentEmail.OriginalFileName+", "}}</a>
                  </div>
              </div> -->
      </div>
      <div class="w-12 mt-3 flex-grow-1 flex flex-column">
        <p
          v-if="this.mailMethod == 'sendEmail'"
          ref="plainEditor"
          class="p-textarea themeWisePickBC flex-grow-1"
          rows="5"
          placeholder=""
          v-html="DraftEmail.Body"
          maxlength="100"
          style="overflow: auto;"
        />
        <Editor
          v-else
          ref="quillEditor"
          class="p-textarea themeWisePickBC flex-grow-1 flex flex-column"
          rows="5"
          placeholder=""
          v-model="DraftEmail.Body"
          maxlength="100"
          editorStyle="flex-grow: 1"
          @load="onQuillReady"
        />
      </div>      
      <hr class="mb-3 mt-1" />
    </div>
    <template #footer>
      <div class="email-dialog">
        
          <div v-if="showTemplateButtons" class="row-left">
            <button class="create-template-button" @click="setTemplate()"> Create Email Template</button>
            <button class="save-template-button" @click="saveDialogue = true">Save Email Template</button>
          </div>

        <div :class="{'row-bottom': showTemplateButtons}">
          <div v-if="showTemplateButtons" class="email-template">
            <div class="apply-left">
              <Checkbox
                name="city"
                value="Chicago"
                v-model="applyEmailTemplate"
                @change="applyTemplateChanged"
                :binary="true"
                :disabled = "this.selectedTemplate.length == 0"
              />
              <label>Apply Saved Email Template</label>
              <Dropdown
                v-model="selectedTemplate"
                :options="emailTemplates"
                optionLabel="EmailTemplateName"
                optionValue="EmailTemplateData"
                class="col form-control border-control documentemail-dropdown"
                placeholder="Select"
                @change="applyTemplateChanged"
              >
                <template #option="slotProps">
                  <div class="dropdown-item-custom">
                    <span>{{ slotProps.option.EmailTemplateName }}</span>

                    <button
                      class="delete-btn"
                      @click.stop="openDeleteTemplate(slotProps.index)"
                    >
                      ✕
                    </button>
                  </div>
                </template>
              </Dropdown>
            </div>
          </div>

          <div>
            <button class="theme-btn" @click="sendEmail()">OK</button>
            <button class="btn-outline" @click="closeEmailDialogue()">Cancel</button>
          </div>

        </div>
      </div>

    </template>
  </Dialog>
        <Dialog
        v-model:visible="saveDialogue"
        header="Save Email Template"
        :style="{ width: '30vw' }"
        class="theme-dialog"
        :modal="true"
      >
        Do you want to save this email template?
        <div
          class="form-group mt-3"
          
        >
          <label class="block">Email Template Name</label>
          <div class="save-filter">
            <input
              type="text"
              class="form-control"
              v-model="v$.saveform.emailTemplateName.$model"
              :v-on:keypress="checkDuplicateName()"
              autofocus
              required
              maxlength="40"
              :class="{ error: v$.saveform.emailTemplateName.$error }"
            />
            <div class="input-errors" v-if="v$.saveform.emailTemplateName.$error">
              Please enter filter name
            </div>
            <div class="input-errors" v-if="templateError !== null">
              {{ templateError }}
            </div>
            <div class="p-dialog-foot">
              <button
                class="theme-btn"
                type="submit"
                @click="saveTemplate('DocumentEmailTemplate')"
              >
                Save
              </button>
              <button class="btn-outline" @click="this.saveDialogue = false;">Cancel</button>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        v-model:visible="deleteTemplateDialogue"
        header="Delete Email Template"
        :style="{ width: '30vw' }"
        class="theme-dialog"
        :modal="true"
      >
        Are you sure you want to delete this email template?

        <template #footer>
          <button
            class="theme-btn"
            :disabled="isTemplateDeleting"
            @click="deleteTemplate(this.selectedTemplateID)"
          >
            Yes
          </button>
          <button class="btn-outline" @click="deleteTemplateDialogue = false">Cancel</button>
        </template>
      </Dialog>
  <vue-element-loading
    :active="isActive"
    spinner="bar-fade-scale"
    color="#FF6700"
    :is-full-screen="true"
  />  
    <Toast position="bottom-right" group="de">
 <template #message="slotProps">
 <span :class="iconClass"></span>
 <div class="p-toast-message-text">
 <span class="p-toast-summary">{{ slotProps.message.summary }}</span>
 <div class="p-toast-detail" v-html="slotProps.message.detail" />
 </div></template>
 </Toast> 
</template>

<script>
import VueElementLoading from "vue-element-loading";
import { dataProvider } from "@/api/dataProvider.js";
import Toast from "primevue/toast";
import Editor from 'primevue/editor';
import Chips from 'primevue/chips';
import { useCCOnEmails } from '@/composables/ccOnEmails';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  props:['emaillist','type'],
  data() {
    return {
        applyEmailTemplate: false,
        isTemplateDeleting: false,
        deleteTemplateDialogue: false,
        saveDialogue: false,
        saveform: {
        emailTemplateName: "",
      },
        v$: useVuelidate( { $scope: false }),
        templateSaved: false,
        templateError: "",
        selectedTemplate: [],
        emailTemplates: [],
        emtpyEmailToError: false,
        isActive:false,
        showEmailDialog: false,
        DraftEmail: {
        SenderAccount: "noreply@shipldi.com",
        Subject: "",
        Body: "",
        IsHtml: true,
        FromAccount: "noreply@shipldi.com",
        EmailTo: [],
        EmailCC: this.ccEmailAddress,
        EmailBCC: [],
        LoadID: 0
        }, 
        attachments:[],             
      selectedDocuments: [],
      mailMethod:'',
      selectedEmail:[]
    };
  },
  mounted: async function() {
    this.getEmailTemplates();
    this.ccEmailAddress = await this.ccOnEmails();
    if(this.emaillist?.length > 0){
    var primaryEmail = this.emaillist[0]
    this.DraftEmail.EmailTo = []
    this.DraftEmail.EmailTo.push(primaryEmail)
    if (this.type !== 'BOL' && this.type !== 'LTLBOL' && this.type !== 'QUOTE') { // Don't set a default To email for these
      this.selectedEmail = [primaryEmail];
      if (this.type == 'INVOICE') this.selectedEmail = this.emaillist;
    }
    }else{
      this.DraftEmail.EmailTo = []
    }
  
  },
  setup () {
    const { ccOnEmails } = useCCOnEmails();

    return {
      ccOnEmails
    };
  },
  components:{
    VueElementLoading,
    Toast,
    Editor,
    Chips
  },
  validations() {
    return {
      saveform: {
        emailTemplateName: { required },
      },
    };
  },
  computed: {
    showTemplateButtons()
    {
      return this.mailMethod !== 'sendEmail' && this.type !== 'QUOTE'
    }
  },
  methods: {
    onQuillReady() {
      this.applyTemplateChanged();
    },
    openDeleteTemplate(index) {
      this.selectedTemplateID = index;
      this.deleteTemplateDialogue = true;
    },
    applyTemplateChanged()
    {
      if (this.applyEmailTemplate) this.setTemplate(this.selectedTemplate.Body)
      else this.setTemplate('');

    },
    setTemplateArray() {
      return JSON.stringify(this.emailTemplates);
    },
    async getEmailTemplates() {
      let keycode = "DocumentEmailTemplate";
      await dataProvider.getColumnSetting(keycode).then((res) => {
        if (res.SettingValue != "") {
          let response = res.SettingValue ? JSON.parse(JSON.stringify(res.SettingValue)) : null;
          this.emailTemplates = JSON.parse(response).sort((a, b) => a.EmailTemplateName.localeCompare(b.EmailTemplateName));
        }
      });
      
    },
    async saveTemplate(keycode) {
      this.v$.saveform.$touch();
      if (this.v$.saveform.$error) return;
      var saveObj = {
        EmailTemplateName: this.saveform.emailTemplateName,
        EmailTemplateData: {
          Body: this.DraftEmail.Body
        },
      };
    
      var index = this.emailTemplates.findIndex(
        (x) =>
          x.EmailTemplateName.toLowerCase() == this.saveform.emailTemplateName.toLowerCase()
      );
      if (index === -1) {
        this.templateSaved = true;
        this.emailTemplates.push(saveObj);
        this.emailTemplates = this.emailTemplates.sort((a, b) => a.EmailTemplateName.localeCompare(b.EmailTemplateName));
      } else {
        this.templateError = "Duplicate filter name";
        setTimeout(() => {
          this.templateError = "";
        }, 3000);
        return;
      }
      var objIndex = this.emailTemplates.findIndex(
        (obj) =>
          obj.EmailTemplateName.toLowerCase() == this.saveform.emailTemplateName.toLowerCase()
      );
      this.emailTemplates[objIndex].EmailTemplateData = saveObj.EmailTemplateData;
      await dataProvider
        .setEmployeeSettings(keycode, this.setTemplateArray())
        .then((data) => {
          this.response1 = data;
          this.saveDialogue = false;
          this.$toast.add({
            severity: "success",
            summary: "Success Message",
            detail: "Filter saved successfully",
            life: 3000,
          });
        });
      this.saveform.emailTemplateName = "";
    },
    async deleteTemplate(templateID) {
      this.isTemplateDeleting = true;
      this.emailTemplates.splice(templateID, 1);
      this.emailTemplates = this.emailTemplates.sort((a, b) => a.EmailTemplateName.localeCompare(b.EmailTemplateName));
      let keycode = "DocumentEmailTemplate";
      await dataProvider
        .setEmployeeSettings(keycode, this.setTemplateArray())
        .then(() => {
          this.deleteTemplateDialogue = false;
          this.$toast.add({
            severity: "success",
            summary: "Success Message",
            detail: "Filter deleted successfully",
            life: 3000,
          });
        });
      this.isTemplateDeleting = false;
    },
    checkDuplicateName() {
      var index = this.emailTemplates.findIndex(
        (x) =>
          x.EmailTemplateName.toLowerCase() == this.saveform.emailTemplateName.toLowerCase()
      );
      if (index === -1) {
        this.templateError = "";
      } else {
        if (this.templateSaved == false) {
          this.templateError = "Duplicate filter name";
        } else {
          this.templateError = "";
        }
      }
    },
    setTemplate(text = null) {
      const html = text != null ? text : `
                    <p>Enter text here to create an email template, then click <i>"Save Email Template"</i> and name the template for future use.</p><br>
                    <p>You may enter the following parameters, using brackets, for load data to automatically flow into the email template:</p>
                    <ul>
                      <li>[Dispatcher], [LoadID], [FirstName], [LastName]</li>
                    </ul>
                  `;

      this.DraftEmail.Body = html;

      this.$nextTick(() => {
        if (this.mailMethod !== 'sendEmail') {
          const quill = this.$refs.quillEditor.quill;
          quill.setContents(quill.clipboard.convert({
            html: html,
          }));
        }
      })

    },
    
    isEmailValid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    validateEmailList(listType) {
      let emailList = [];   
      // Get the appropriate email list based on the type
      if (listType === 'to') emailList = this.selectedEmail;
      if (listType === 'cc') emailList = this.DraftEmail.EmailCC;
      if (listType === 'bcc') emailList = this.DraftEmail.EmailBCC;

      // Process the email list
      let formattedEmails = emailList
        .flatMap(email => email.split(/[ ,;]+/)) // Split by delimiters
        .map(email => email.trim())            // Remove whitespace
        .filter(Boolean);                      // Remove empty strings

      // Remove duplicates and limit to 50 emails
      const uniqueEmails = [...new Set(formattedEmails)].slice(0, 50);

      // Assign the processed list back to the appropriate property
      if (listType === 'to') {
        this.selectedEmail = uniqueEmails;
        this.updateEmailList()
      }
      if (listType === 'cc') this.DraftEmail.EmailCC = uniqueEmails;
      if (listType === 'bcc') this.DraftEmail.EmailBCC = uniqueEmails;
    },
    removeEmail(removedEmail,listType) {
      // Determine the appropriate list based on the list type
      let emailList = [];
      if (listType === 'to') emailList = this.selectedEmail;
      if (listType === 'cc') emailList = this.DraftEmail.EmailCC;
      if (listType === 'bcc') emailList = this.DraftEmail.EmailBCC;

      // Remove the selected email from the list
      emailList = emailList.filter((email) => email !== removedEmail);

      // Update the email list back to the original variable
      if (listType === 'to') {
        this.selectedEmail = emailList;
        this.updateEmailList()
      }
      if (listType === 'cc') this.DraftEmail.EmailCC = emailList;
      if (listType === 'bcc') this.DraftEmail.EmailBCC = emailList;
    },
    updateEmailList(){   
    this.DraftEmail.EmailTo = this.selectedEmail
    },
    changeSelectedEmail(email){
      var primaryEmail = email.value;
    this.DraftEmail.EmailTo = []
    this.DraftEmail.EmailTo.push(primaryEmail)
  
    },
    closeEmailDialogue() {
      this.showEmailDialog = false;
      this.emtpyEmailToError = false;
      this.selectedDocuments = [];
      this.DraftEmail= {
        SenderAccount: "noreply@shipldi.com",
        Subject: "",
        Body: "",
        IsHtml: true,
        FromAccount: "noreply@shipldi.com",
        EmailTo: [],
        EmailCC: this.ccEmailAddress,
        EmailBCC: [],
        LoadID: 0
        } 
        this.attachments=[]               
    },
    areAllEmailsValid(emails) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emails.every(email => emailRegex.test(email));
    },
    async sendEmail() {
        const allEmails = (this.type!='RCON' && this.type!='RCONBOL') ? [
          ...this.selectedEmail,
          ...this.DraftEmail.EmailCC,
          ...this.DraftEmail.EmailBCC,
        ]:[
          ...this.DraftEmail.EmailCC,
          ...this.DraftEmail.EmailBCC,
        ];

        if (!this.areAllEmailsValid(allEmails)) {
          this.$toast.add({
            severity: "error",
            summary: "Invalid Emails",
            detail: "Some email addresses are invalid. Please correct them.",
            group: 'de'
          });
          return false;
        }
        if(this.DraftEmail.EmailTo.length == 0){
                  this.emtpyEmailToError = true;
                        this.$toast.add({
                        severity: "error",
                        summary: "error",
                        detail: "Please enter a email address",
                        group: 'de'
                        });    
                        return false;          
        }else{this.emtpyEmailToError = false;}


            if(this.mailMethod == "sendEmail"){
            this.isActive = true;

            await dataProvider.sendEmail(this.DraftEmail).then((res)=>{
                if(res)
                {
                    if(res.Success){
                        this.$toast.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Mail sent successfully.",
                        life: 3000,
                        group: 'de'
                        });
                    }
                }
            });
            this.isActive = false;
        }

        if(this.mailMethod == "sendEmailWithDocuments"){
                    this.isActive = true;
      await dataProvider.sendEmailWithDocuments(this.DraftEmail).then((res)=>{
        if(res)
        {
            if(res.Success){
                this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Mail sent successfully.",
                life: 3000,
                group: 'de'
                });
            }
        }
      });
                  this.isActive = false;
    }

        if(this.mailMethod == "sendEmailWithAttachments"){
            this.isActive = true;
      await dataProvider.sendEmailWithAttachments(this.DraftEmail).then((res)=>{
        if(res)
        {
            if(res.Success){
                this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Mail sent successfully.",
                life: 3000,
                group: 'de'
                });
            }
        }
      });
            this.isActive = false;
    }
      this.showEmailDialog = false;
      this.emtpyEmailToError = false;
      this.selectedDocuments = [];
       this.selectedEmail = this.primaryEmail;
    },  
    openEmailfromSourceLoad(draftEmail) {
      this.DraftEmail = draftEmail;      
      this.showEmailDialog = true;
      this.mailMethod = "sendEmail"; 
    },    
    openEmailfromLDIAgentDocs(draftEmail, selectedDocs, attachmentsArray) {
      draftEmail.EmailTo = '';
      this.DraftEmail = draftEmail;
      this.attachments = attachmentsArray;
      this.selectedDocuments = selectedDocs;
      var documents = this.selectedDocuments.map((p) => p.DocumentID);
      this.DraftEmail.Documents = documents;        
      this.showEmailDialog = true;
      this.mailMethod = "sendEmailWithDocuments";
    },
    openEmailfromCarrierDocument(draftEmail, selectedDocs, attachmentsArray) {
      this.DraftEmail = draftEmail;
      this.attachments = attachmentsArray;
      this.selectedDocuments = selectedDocs;
      var documents = this.selectedDocuments.map((p) => p.DocumentID);
      this.DraftEmail.Documents = documents;  
      this.showEmailDialog = true;
      this.mailMethod = "sendEmailWithDocuments";        
    },
    openEmailfromReportViewer(draftEmail, attachmentsArray) {
      this.DraftEmail = draftEmail;
      this.DraftEmail.EmailTo = Array.isArray(this.selectedEmail) ? [...this.selectedEmail] : [this.selectedEmail];
      this.attachments = attachmentsArray;      
      this.showEmailDialog = true;
      this.mailMethod = "sendEmailWithAttachments";  
    },    
  },
};
</script>

<style lang="scss">


.row-left {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}

.row-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 20px;
}

.apply-left {
  display: flex;
  align-items: center;
  gap: 8px;

  .p-dropdown {
    width: 200px;  
    display: inline-flex;
    align-items: center;

    .p-dropdown-label {
      width: 100%;
      white-space: nowrap;
      text-align: left;
    }
  }

  label {
    font-size: small !important;
  }
}

.ql-editor ol li[data-list="bullet"]::before {
    content: '\2022';
}

.create-template-button {
  background: var(--button-primary-bg) !important;
  border:1px solid var(--button-border) !important;
  color: var(--text-button) !important;

  padding: 6px 20px;
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--border-button);
  border-radius: 4px;
} 

.save-template-button {
  background: var(--button-secondary-bg);
  border:1px solid var(--button-border);
  color: var(--text-button);

  padding: 6px 20px;
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--border-button);
  border-radius: 4px;
}   

.input-errors {
  margin-top: 4px;
  font-size: 14px;
  color: var(--badge-danger);
}

.dropdown-item-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.delete-btn {
  color: var(--badge-danger);
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 0 4px;
}

.delete-btn:hover {
  color: var(--badge-danger);
}
.document-email {
  .leftMargin{
    margin-left: 5.5rem;
  }
  .p-chips .p-chips-multiple-container .p-chips-input-token{
    width: 100%!important;
    margin: top 3px !important;
    input{
      width: 100%!important;
      border:none;
      font-size: 14px !important;
      padding : 0.2rem 0.5rem !important;
    }
  }
  .p-chips .p-chips-multiple-container{
    display: table !important;
    padding: 0.2rem !important;
    height: 30px !important;
    width: 100% !important;
  }
  .p-chips{
    max-height: 200px !important;
    overflow-y: auto !important;
  }
  height: 100%;
  .chipError{
    border:1px solid var(--badge-danger);
  }
 .deerror {
  .email-form-control {
    border: 1px solid var(--badge-danger);

    .p-button {
      border: 1px solid transparent;
      border-left: 1px solid var(--badge-danger);
    }
  }
} 
  .email-form-control {
   
    padding: 10px;
    border-radius: 1px;
    height: 30px;
    display: inline-block;
    width: 100%;
  }
  .attach-form-control {
   
    padding: 4px 4px 4px 10px;
    border-radius: 1px;
    height: 30px;
    display: inline-block;
    width: 100%;
  }
  .label {
    font-weight: 400;
    width: 12ch;
    padding: 0px;
  }
  .email-docs {
    font-weight: 500;
    color: var(--add);
    cursor: pointer;
  }
  .documentemail-dropdown{
      display: inline-flex;
      .p-dropdown-label{
      font-size: 14px;
      }
      .p-dropdown-label.p-placeholder{
        color: var(--text-muted);
      }
  }
}
</style>